export default __webpack_public_path__ + "static/media/arrow-standard.81f0ce35.png";